import { ReducerFnInterface } from '@context/type';
import { JourneyGetResponseMonitoringInterface } from '@interface/journeys';
import { JourneysStateInterface } from './journeys.type';

export const journeysReducer: ReducerFnInterface<JourneysStateInterface> = (
  state,
  { type, payload },
) => {
  switch (type) {
    case 'journeys_update_current_page':
      return {
        ...state,
        all: {
          ...state.all,
          currentPage: payload.currentPage,
        },
      };
    case 'journeys_load':
      return {
        ...state,
        all: {
          ...state.all,
          isFetching: true,
          isFetched: false,
          data: [],
          error: false,
        },
      };
    case 'journeys_load_success':
      return {
        ...state,
        all: {
          ...state.all,
          isFetching: false,
          isFetched: true,
          data: payload.journeyResponse.data || [],
          meta: {
            ...payload.journeyResponse.meta,
          },
          error: false,
        },
      };
    case 'journeys_load_error':
      return {
        ...state,
        all: {
          ...state.all,
          isFetching: false,
          isFetched: true,
          data: [],
          meta: {
            next: null,
            page: 1,
            previous: null,
            total: 0,
            lastUpdate: '',
          },
          error: true,
        },
        errorStatus: payload.statusCode,
      };
    case 'journeys_selection_set':
      return {
        ...state,
        selection: {
          ...state.selection,
          isError: false,
          isFetching: false,
          data: payload.data,
        },
      };
    case 'journeys_selection_clear':
      return {
        ...state,
        selection: {
          isFetching: false,
          isError: payload?.isError || false,
          data: null,
          historyEvents: {
            isFetching: true,
            isError: false,
            data: [],
          },
        },
      };

    case 'journeys_selection_error':
      return {
        ...state,
        selection: {
          ...state.selection,
          isFetching: false,
          isError: payload.isError,
        },
      };

    case 'journeys_selection_fetching':
      return {
        ...state,
        selection: {
          ...state.selection,
          isError: false,
          isFetching: payload.isFetching,
          historyEvents: {
            ...state.selection.historyEvents,
            isFetching: true,
          },
        },
      };

    case 'journey_last_location_loading': {
      const newJourneys = state.all.data.map((journey) => {
        const tempJourney = { ...journey };

        if (tempJourney.id === payload.journeyId) {
          tempJourney.lastLocationState = {
            fetch: {
              isFetching: payload.isFetching,
            },
            error: {
              code: null,
              message: '',
            },
            description: '',
            updateAt: null,
          };
        }

        return tempJourney;
      });

      return {
        ...state,
        all: {
          ...state.all,
          data: newJourneys,
        },
      };
    }

    case 'journey_last_location_loaded': {
      const newJourneys = state.all.data.map((journey) => {
        const tempJourney = { ...journey };

        if (tempJourney.id === payload.journeyId) {
          tempJourney.lastLocationState = {
            fetch: {
              isFetching: false,
            },
            error: {
              code: null,
              message: '',
            },
            description: payload.description,
            updateAt: new Date().getTime(),
          };
          if (payload.lastLocation) {
            tempJourney.trucker.lastLocation = payload.lastLocation;
          }
        }

        return tempJourney;
      });

      return {
        ...state,
        all: {
          ...state.all,
          data: newJourneys,
        },
      };
    }

    case 'journey_update_address': {
      let tempJourneySelection:
        | JourneyGetResponseMonitoringInterface['data']
        | null = null;

      if (!payload.delivery && !payload.pickup) {
        return state;
      }

      const newJourneys = state.all.data.map((journey) => {
        const tempJourney = { ...journey };

        if (tempJourney.id === payload.journeyId) {
          tempJourney.status.slug = 'in_progress';
          if (payload.delivery) {
            tempJourney.address.delivery = `${payload.delivery.place.city.name}, ${payload.delivery.place.state.acronym}`;
          }

          if (payload.pickup) {
            tempJourney.address.pickup = `${payload.pickup.place.city.name}, ${payload.pickup.place.state.acronym}`;
          }

          if (state.selection.data) {
            tempJourneySelection = state.selection.data;
            tempJourneySelection.journey.status.slug = 'in_progress';
            tempJourneySelection.journey.status.label = 'in_progress';

            if (payload.delivery) {
              tempJourneySelection.journey.address.delivery.description = `${payload.delivery.place.city.name}, ${payload.delivery.place.state.acronym}`;
              tempJourneySelection.journey.address.delivery.city =
                payload.delivery.place.city;

              if (payload.delivery.place.address) {
                tempJourneySelection.journey.address.delivery.description = `${payload.delivery.place.address} - ${tempJourneySelection.journey.address.delivery.description}`;
              }
            }

            if (payload.pickup) {
              tempJourneySelection.journey.address.pickup.description = `${payload.pickup.place.city.name}, ${payload.pickup.place.state.acronym}`;
              tempJourneySelection.journey.address.pickup.city =
                payload.pickup.place.city;

              if (payload.pickup.place.address) {
                tempJourneySelection.journey.address.pickup.description = `${payload.pickup.place.address} - ${tempJourneySelection.journey.address.pickup.description}`;
              }
            }
          }
        }

        return tempJourney;
      });

      return {
        ...state,
        all: {
          ...state.all,
          data: newJourneys,
        },
        selection: {
          ...state.selection,
          data: tempJourneySelection,
        },
      };
    }

    case 'journey_last_location_error': {
      const newJourneys = state.all.data.map((journey) => {
        const tempJourney = { ...journey };

        if (tempJourney.id === payload.journeyId) {
          tempJourney.lastLocationState = {
            fetch: {
              isFetching: false,
            },
            error: {
              code: payload.code,
              message: payload.message,
            },
            description: payload.description,
            updateAt: new Date().getTime(),
          };
        }

        return tempJourney;
      });

      return {
        ...state,
        all: {
          ...state.all,
          data: newJourneys,
        },
      };
    }
    case 'journey_last_location_description': {
      const newJourneys = state.all.data.map((journey) => {
        const tempJourney = { ...journey };

        if (tempJourney.id === payload.journeyId) {
          if (tempJourney.lastLocationState) {
            tempJourney.lastLocationState.description = payload.description;
          }

          if (!tempJourney.lastLocationState) {
            tempJourney.lastLocationState = {
              fetch: {
                isFetching: false,
              },
              error: {
                code: null,
                message: '',
              },
              description: payload.description,
              updateAt: new Date().getTime(),
            };
          }
        }

        return tempJourney;
      });

      return {
        ...state,
        all: {
          ...state.all,
          data: newJourneys,
        },
      };
    }

    case 'journey_toggle_selection_marker': {
      const newJourneys = state.all.data.map((journey) => {
        const tempJourney = { ...journey };

        if (tempJourney.id === payload.journeyId) {
          tempJourney.isMarker = !tempJourney.isMarker;
          return tempJourney;
        }

        tempJourney.isMarker = false;

        return tempJourney;
      });
      return {
        ...state,
        all: {
          ...state.all,
          data: newJourneys,
        },
      };
    }

    case 'journey_clear_selection_marker': {
      const newJourneys = state.all.data.map((journey) => {
        const tempJourney = { ...journey };

        tempJourney.isMarker = false;

        return tempJourney;
      });
      return {
        ...state,
        all: {
          ...state.all,
          data: newJourneys,
        },
      };
    }

    case 'journey_occurrence_read': {
      const newJourneys = state.all.data.map((journey) => {
        const tempJourney = { ...journey };

        if (tempJourney.id === payload.journeyId) {
          tempJourney.occurrence.read = payload.read;
        }

        return tempJourney;
      });

      const selectionTemp = { ...state.selection };

      if (selectionTemp.data && selectionTemp.data.journey.occurrences.length) {
        selectionTemp.data.journey.occurrences =
          selectionTemp.data.journey.occurrences.map((occurrency) => {
            const tempOccurrency = { ...occurrency };

            if (tempOccurrency.id === payload.occurrenceId) {
              tempOccurrency.read = payload.read;
            }

            return tempOccurrency;
          });
      }

      if (selectionTemp.historyEvents.data.length) {
        selectionTemp.historyEvents.data = selectionTemp.historyEvents.data.map(
          (event) => {
            const tempEvent = { ...event };

            if (tempEvent.id === payload.occurrenceId) {
              tempEvent.read = payload.read;
            }

            return tempEvent;
          },
        );
      }

      return {
        ...state,
        all: {
          ...state.all,
          data: newJourneys,
        },
        selection: selectionTemp,
      };
    }

    case 'journey_occurrence_remove': {
      const newJourneys = state.all.data.map((journey) => {
        const tempJourney = { ...journey };

        if (tempJourney.id === payload.journeyId) {
          tempJourney.occurrence.read = true;
        }

        return tempJourney;
      });

      return {
        ...state,
        all: {
          ...state.all,
          data: newJourneys,
        },
      };
    }

    case 'journey_history_loading': {
      return {
        ...state,
        selection: {
          ...state.selection,
          historyEvents: {
            ...state.selection.historyEvents,
            isFetching: true,
            isError: false,
          },
        },
      };
    }

    case 'journey_history_error': {
      return {
        ...state,
        selection: {
          ...state.selection,
          historyEvents: {
            isFetching: false,
            isError: true,
            data: [],
          },
        },
      };
    }

    case 'journey_history_success': {
      return {
        ...state,
        selection: {
          ...state.selection,
          historyEvents: {
            isFetching: false,
            isError: false,
            data: payload,
          },
        },
      };
    }

    default:
      return state;
  }
};

journeysReducer.key = 'journeys';
journeysReducer.initialState = {
  all: {
    isFetching: true,
    isFetched: false,
    currentPage: 1,
    data: [],
    meta: {
      next: null,
      page: 1,
      previous: null,
      total: 0,
      lastUpdate: '',
    },
    error: false,
  },
  selection: {
    isFetching: false,
    isError: false,
    data: null,
    historyEvents: {
      isFetching: true,
      isError: false,
      data: [],
    },
  },
};
